import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { projects } from '@/data/portfolio';
import { Link } from 'wouter';

const StarIcon = ({ className }: { className?: string }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 20 20">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>
);

export const FeaturedProjects = () => {
  const featuredProjects = projects.filter(p => p.featured);
  
  if (featuredProjects.length === 0) return null;
  
  return (
    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-6">Featured Projects</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {featuredProjects.map(project => (
          <div key={project.id} className="animate-float hover:shadow-lg transition-shadow">
            <div className="relative group overflow-hidden rounded-xl">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent rounded-xl group-hover:opacity-100 opacity-0 transition-opacity duration-500" />
              
              <img 
                src={project.previewImage}
                alt={project.name}
                className="w-full h-64 object-cover rounded-xl transition-transform duration-700 group-hover:scale-105"
              />
              
              <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-gray-900 to-transparent rounded-b-xl">
                <h3 className="text-xl font-bold text-white">{project.name}</h3>
                <p className="text-sm text-gray-300 mt-2">{project.description}</p>
                
                <div className="mt-4 flex justify-between items-center">
                  <Link href="/portfolio">
                    <Button 
                      variant="outline" 
                      className="px-4 py-2 bg-transparent border-white/20 hover:bg-white/10 hover:border-white/30 text-white"
                    >
                      View Case Study
                    </Button>
                  </Link>
                  
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <StarIcon key={i} className={`w-4 h-4 ${i < 4 ? 'text-yellow-400' : 'text-gray-500'}`} />
                    ))}
                  </div>
                </div>
              </div>
              
              <div className="absolute top-4 right-4">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary/90 text-white">
                  Featured
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
